import { CloseOutlined } from '@ant-design/icons';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useOnClickOutside } from '../../../../hooks/use_on_click_outside';
import { getStatesAlphabetical } from '../../../../redux/reference_data';
import SvgBoatRampPrivate from '../../../svg/boat_ramp_private';
import SvgBoatRampPublic from '../../../svg/boat_ramp_public';
import SvgPrivateIcon from '../../../svg/private_icon';
import SvgPublicIcon from '../../../svg/public_icon';
import { BoatLanding } from '../../map_types';
import styles from './boat_landing_modal.less';

interface BoatLandingModalProps {
  boatLanding: BoatLanding;
  onClose: () => void;
  isOpen: boolean;
}
export const BoatLandingModal = React.memo((props: BoatLandingModalProps) => {
  const { boatLanding, onClose, isOpen } = props;
  const containerRef = useRef<HTMLDivElement>();
  const allStates = useSelector(getStatesAlphabetical);

  useOnClickOutside(containerRef, onClose, 'mousedown', 'touchstart');

  if (!boatLanding) {
    return null;
  }

  const isBoatLandingPrivate = boatLanding.Type === 'Semi-Private';
  const boatLandingStateAbbreviation = allStates.find(
    (state) => state.name.toLowerCase() === boatLanding.State.toLowerCase()
  )?.abbr;

  return (
    <div className={styles.boatLandingModal}>
      {isOpen && (
        <div className={styles.modalWrapper} ref={containerRef}>
          <div className={styles.modalHeader}>
            <div className={styles.iconWrapper}>
              {isBoatLandingPrivate ? <SvgBoatRampPrivate /> : <SvgBoatRampPublic />}
            </div>
            <div className={styles.details}>
              <p className={styles.landingName}>{boatLanding?.AccessName} </p>
              <span className={styles.locationLine}>
                <span>Boat Ramp</span>
                <span>
                  {boatLanding.County}, {boatLandingStateAbbreviation}
                </span>
              </span>
              <span className={styles.boatLandingType}>
                <span className={styles.smallIconWrapper}>
                  {isBoatLandingPrivate ? <SvgPrivateIcon /> : <SvgPublicIcon />}{' '}
                </span>
                {boatLanding.Type}
              </span>
            </div>
            <CloseOutlined onClick={onClose} />
          </div>
        </div>
      )}
    </div>
  );
});
